import { SalesforceNamespace } from 'datasource-service-lib';
import { IDataSourceApiService, IEntity, IFileDataSourceApiService, IMergeFile } from 'interfaces-lib';
import { forkJoin, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { IPreMergeChecker } from '../../interfaces/ipremergechecker';
import { MergeBasketViewComponent } from '../../merge-basket-view/merge-basket-view.component';
import { buildSalesforceContactDocumentParameters } from '../../utils/salesforce-contact-document-helpers';
import { ServiceProviderService } from '../service.provider.service';
import { SharedServiceProviderServiceFactory } from 'shared-service-provider-lib';

export class SalesforcePreMergeCheck implements IPreMergeChecker {
  private dataSourceApiService: IDataSourceApiService;
  readonly fileDataSourceApiService: IFileDataSourceApiService;

  // @TODO: work on premerge check for salesforce
  constructor(serviceProviderService: ServiceProviderService, sharedServiceProvider: SharedServiceProviderServiceFactory) {
    this.dataSourceApiService = serviceProviderService.getDataSourceApiService(SalesforceNamespace.name);
    this.fileDataSourceApiService = sharedServiceProvider.getServiceProviderService(SalesforceNamespace.name).getFileDataSourceApiService();
  }

  check(entity: IEntity, filename: string): Observable<boolean> {
    // TODO: we could check for special illegal characters
    return of(true);
  }

  checkFilesExist(files: IMergeFile[]): Observable<any> {
    const files$: Observable<{ ok: boolean; file: any }>[] = [];

    files.forEach((file) => {
      if (file.type === MergeBasketViewComponent.LOCAL_FILE) {
        files$.push(of({ ok: true, file }));
      } else if (file.type === MergeBasketViewComponent.FILE_ATTACHMENT) {
        const parameters = buildSalesforceContactDocumentParameters(SalesforceNamespace.name, file);
        files$.push(
          this.fileDataSourceApiService
            .checkFile(file.id, {
              entity: file.belongsTo,
              parameters,
            })
            .pipe(
              map((ok) => {
                return { ok, file };
              }),
            ),
        );
      } else {
        throw new Error(`File type '${file.type}' not recognised for file: ${file.name}`);
      }
    });

    return forkJoin(files$).pipe(map((results) => results.filter((r) => !r.ok).map((r) => r.file)));
  }
}
